import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import BaseURL from '../../assets/contants/BaseURL';

const STORAGE_KEY = 'ems_custom_dashboard_meter_id';

function loadStoredMeterId() {
    try {
        return localStorage.getItem(STORAGE_KEY) || '';
    } catch (err) {
        return '';
    }
}

// One dashboard-wide meter selection, shared by every widget, instead of
// each widget defaulting to the hardcoded TEST_1_1 meter id.
export default function useSelectedMeter() {
    const [meters, setMeters] = useState([]);
    const [selectedMeterId, setSelectedMeterIdState] = useState(loadStoredMeterId);

    useEffect(() => {
        let cancelled = false;
        axios.get(`${BaseURL}meters/energymeters/`)
            .then((res) => {
                if (cancelled) return;
                const list = Array.isArray(res.data) ? res.data : [];
                setMeters(list);
                setSelectedMeterIdState((prev) => (
                    prev && list.some((m) => m.meter_id === prev) ? prev : (list[0]?.meter_id || '')
                ));
            })
            .catch((err) => console.error('useSelectedMeter: failed to load meters', err));
        return () => { cancelled = true; };
    }, []);

    const setSelectedMeterId = useCallback((meterId) => {
        setSelectedMeterIdState(meterId);
        try {
            localStorage.setItem(STORAGE_KEY, meterId);
        } catch (err) {
            // ignore storage failures (e.g. private browsing)
        }
    }, []);

    return { meters, selectedMeterId, setSelectedMeterId };
}
